<script setup lang="ts">
import { cn } from '../../../lib/utils';

const props = defineProps<{
  class?: string
}>()
</script>
<template>
  <h1 :class="cn('font-bold text-base text-slate-500', props.class)"><slot /></h1>
</template>
